import { render, staticRenderFns } from "./IDMLPreview.vue?vue&type=template&id=a202e13c&scoped=true"
import script from "./IDMLPreview.vue?vue&type=script&lang=js"
export * from "./IDMLPreview.vue?vue&type=script&lang=js"
import style0 from "./IDMLPreview.vue?vue&type=style&index=0&id=a202e13c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a202e13c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a202e13c')) {
      api.createRecord('a202e13c', component.options)
    } else {
      api.reload('a202e13c', component.options)
    }
    module.hot.accept("./IDMLPreview.vue?vue&type=template&id=a202e13c&scoped=true", function () {
      api.rerender('a202e13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/idml-layers/IDMLPreview.vue"
export default component.exports